import React, { FunctionComponent, useCallback, useEffect, useState } from "react";
import styles from "./CategoryPage.module.scss";
import CategoryPageContent from "./CategoryPageContent.model";
import CategoryPageBlock from "./CategoryPage.block";

import Dictionary from "components/Dictionary/Dictionary";
import ProductCard from "./components/ProductCard";
import Sidemenu from "layout/Sidemenu/Sidemenu";
import Spinner from "components/Spinner/Spinner";
import useProducts from "./hooks/useProducts";
import useWindowDimensions from "hooks/useWindowDimensions";
import IconViewer from "components/IconViewer/IconViewer";
import combineClasses from "helpers/combine-classes";
import { useDispatch, useSelector } from "react-redux";
import { OPEN_FACETS_MENU } from "layout/redux/overlay.actions";

const CategoryPage: FunctionComponent<CategoryPageContent> = (props) => {
    const [items, viewState] = useProducts(props.category?.id);
    const language = useSelector((state: any) => state.page.languageId);

    const dispatch = useDispatch();
    const { width } = useWindowDimensions();
    const overlay = useSelector((state: any) => state.overlay);

    const [showSidemenu, setShowSidemenu] = useState<boolean>(false);
    const menuViewState = width >= 768 ? "FIXED" : width >= 450 ? "FLOAT" : "FULL";
    const toggleMenuClass = showSidemenu && overlay.currentOverlay === "FACETS_MENU" ? styles.is_open : undefined;

    useEffect(() => {
        if (width >= 768) {
            setShowSidemenu(true);
        }
    }, [width]);

    const toggleMenu = useCallback(() => {
        if (showSidemenu && overlay.currentOverlay === "FACETS_MENU") {
            setShowSidemenu(false);
        } else {
            dispatch({ type: OPEN_FACETS_MENU });
            setShowSidemenu(true);
        }
    }, [showSidemenu, overlay]);

    return (
        <div className={styles.inner}>
            {/* Toggle */}
            {width < 768 ? (
                <button
                    className={combineClasses([styles.menu_toggle, toggleMenuClass])}
                    onClick={() => toggleMenu()}
                >
                    <div className={styles.menu_toggle_inner}>
                        <Dictionary name="CATEGORY.SHOW_FACETS" />
                        <IconViewer
                            className={styles.chevron}
                            name="chevronDown"
                            heightRatio={7.805 / 12.781}
                        />
                    </div>
                </button>
            ) : null}

            {/* Sidemenu */}
            {showSidemenu === true && ((menuViewState === "FULL" && overlay.currentOverlay === "FACETS_MENU") || menuViewState !== "FULL") ? (
                <Sidemenu view={menuViewState} />
            ) : null}

            <div className={styles.container}>
                {viewState === "LOADING" ? <Spinner className={styles.spinner} /> : null}

                {/* List */}
                {viewState === "LOADED" ? (
                    <div className={styles.list}>
                        {items?.map((item: any) => {
                            return (
                                <ProductCard
                                    key={item.id}
                                    language={language}
                                    {...item}
                                />
                            );
                        })}
                    </div>
                ) : null}

                {viewState === "EMPTY" ? (
                    <div className={styles.empty}>
                        <Dictionary name="CATEGORY.EMPTY" />
                    </div>
                ) : null}

                {/* Content Template */}
                <div className={styles.content}>
                    {props.blocks?.map((blockContent: any, index) => {
                        return (
                            <CategoryPageBlock
                                key={blockContent.contentUdi}
                                {...blockContent}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default CategoryPage;
